import { create } from 'zustand';

export const useMenuDrawStore = create(set => ({
  menuDraw: null,
  setMenuDraw: menuDraw => set({ menuDraw }),
}));
